import { PageFilter } from './page-filter';

export class JobFilter extends PageFilter {
    pageSize?: number;
    from?: Date;
    to?: Date;
}
